const allowedExtensions = new Set([
  '.csv', '.jpeg', '.jpg', '.png',
  '.xlsx', '.doc', '.docx', '.pdf',
  '.json', '.odt', '.rtf', '.txt'
]);

const allowedMimeTypes = new Set([
  'text/csv',
  'image/jpeg',
  'image/png',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/pdf',
  'application/json',
  'application/vnd.oasis.opendocument.text',
  'application/rtf',
  'text/plain'
]);

export function isAllowedFile(file: File): boolean {
  const extension = '.' + file.name.split('.').pop()?.toLowerCase();
  const mimeType = file.type;

  return allowedExtensions.has(extension) && allowedMimeTypes.has(mimeType);
}